module.exports = __webpack_public_path__ + "cffd0a0b7545a025892b1dca042f33f4.png";